import Easing from "./Easing";
/**
 * 节点沿着路径平滑移动
 * @param {ht.Node} node 动画节点
 * @param {ht.Polyline} path 运行路径
 * @param {String} direction 朝向 forward | backward
 * @param {Object} animParams 动画参数
 */
export function move(node, path, direction, step = 6, interval = 75, animParams) {
    let cache = path.__cache__;
    if (!cache)
        cache = path.__cache__ = ht.Default.getLineCacheInfo(path.getPoints(), path.getSegments());

    const len = ht.Default.getLineLength(cache);

    animParams = animParams || {};

    const face = direction === 'forward' ? 'front' : direction === 'backward' ? 'back' : direction;
    let currentLen = 0;
    const pathEndFunc = animParams.pathEndFunc;
    const action = animParams.action;
    animParams.action = (v, t) => {
        if (currentLen >= len) {
            // 档 pathEndFunc 返回 true 是，认为是要结束动画, 不执行后面档 action
            if (pathEndFunc && pathEndFunc())
                return;
        }
        currentLen = currentLen % len;

        const offset = ht.Default.getLineOffset(cache, currentLen);
        const point = offset.point;

        node.lookAtX([point.x, node.getElevation(), point.z], face);
        node.p3(point.x, node.getElevation(), point.z);

        currentLen = currentLen + step;

        if (action) action();
    };
    return loop(animParams.action, interval);
}

/**
 * 循环
 * @param {Function} action 循环执行函数
 * @param {Int} [interval] 循环间隔，默认 20
 */
export function loop(action, interval = 20) {
    return ht.Default.startAnim({
        frames: Infinity,
        interval: interval,
        action: action
    });
}

export function tweenColor(node, property, startColor, endColor, animParams) {
    animParams = animParams || {};
    if (!animParams.frames && !animParams.duration)
        animParams.duration = 5000;
    if (!animParams.easing)
        animParams.easing = t => t;

    startColor = ht.Default.toColorData(startColor);
    endColor = ht.Default.toColorData(endColor);

    const dx = endColor[0] - startColor[0];
    const dy = endColor[1] - startColor[1];
    const dz = endColor[2] - startColor[2];
    const da = endColor[3] - startColor[3];
    const postAction = animParams.postAction;
    animParams.action = (v, t) => {
        const x = startColor[0] + v * dx;
        const y = startColor[1] + v * dy;
        const z = startColor[2] + v * dz;
        const a = (startColor[3] + v * da) / 255;

        node.s(property, ('rgba(' + ([x, y, z, a]).join(', ')) + ')');

        if (postAction) postAction(('rgba(' + ([x, y, z, a]).join(', ')) + ')');
    }
    return ht.Default.startAnim(animParams);
}

export function setNodeVisible(node, visible, cascadeChild = false) {
    node.s({
        '2d.visible': visible,
        '3d.visible': visible
    });

    if (!cascadeChild) return;

    node.eachChild(c => setNodeVisible(c, visible, cascadeChild));
}

export function moveCamera(g3d, eye, center, anim) {
    var lastEye = g3d.getEye();
    lastEye = [lastEye[0], lastEye[1], lastEye[2]];
    var lastCenter = g3d.getCenter();
    lastCenter = [lastCenter[0], lastCenter[1], lastCenter[2]];
    if (!eye) eye = lastEye;
    if (!center) center = lastCenter;

    anim = anim || {};

    // 动画
    var eyeOffset = [eye[0] - lastEye[0], eye[1] - lastEye[1], eye[2] - lastEye[2]];
    var centerOffset = [center[0] - lastCenter[0], center[1] - lastCenter[1], center[2] - lastCenter[2]];

    anim.action = function (t) {
        g3d.setCenter(
            lastCenter[0] + centerOffset[0] * t,
            lastCenter[1] + centerOffset[1] * t,
            lastCenter[2] + centerOffset[2] * t);
        g3d.setEye(
            lastEye[0] + eyeOffset[0] * t,
            lastEye[1] + eyeOffset[1] * t,
            lastEye[2] + eyeOffset[2] * t);
    };
    return ht.Default.startAnim(anim);
}



export function setValueWithAnimation(node, name, value, format, accesstype = 'a') {
    let oldValue;
    if (accesstype === 'a') {
        oldValue = node.a(name);
    } else if (accesstype === 's') {
        oldValue = node.s(name);
    } else {
        oldValue = node[ht.Default.getter(name)]();
    }
    value *= 1;
    let range = value - oldValue;

    ht.Default.startAnim({
        // frames: 32,
        // interval: 10,
        duration: 1000,
        easing: function (t) {
            return 1 - (--t) * t * t * t;
        },
        action: (v, t) => {
            let newValue = oldValue + range * v;
            if (format) {
                newValue = format(newValue);
            }
            if (accesstype === 'a') {
                node.a(name, newValue);
            } else if (accesstype === 's') {
                node.s(name, newValue);
            } else {
                node[ht.Default.setter(name)](newValue);
            }
        }
    });
}

export function formatDate(date, formatStr) {
    var str = formatStr;
    var Week = ['日', '一', '二', '三', '四', '五', '六'];

    str = str.replace(/yyyy|YYYY/, date.getFullYear());
    str = str.replace(/yy|YY/, (date.getYear() % 100) > 9 ? (date.getYear() % 100).toString() : '0' + (date.getYear() % 100));
    var month = date.getMonth() + 1;
    str = str.replace(/MM/, month > 9 ? month.toString() : '0' + month);
    str = str.replace(/M/g, month);

    str = str.replace(/w|W/g, Week[date.getDay()]);

    str = str.replace(/dd|DD/, date.getDate() > 9 ? date.getDate().toString() : '0' + date.getDate());
    str = str.replace(/d|D/g, date.getDate());

    str = str.replace(/hh|HH/, date.getHours() > 9 ? date.getHours().toString() : '0' + date.getHours());
    str = str.replace(/h|H/g, date.getHours());
    str = str.replace(/mm/, date.getMinutes() > 9 ? date.getMinutes().toString() : '0' + date.getMinutes());
    str = str.replace(/m/g, date.getMinutes());
    str = str.replace(/ss|SS/, date.getSeconds() > 9 ? date.getSeconds().toString() : '0' + date.getSeconds());
    str = str.replace(/s|S/g, date.getSeconds());

    return str;
}

export function formatDay(date) {
    date = date.substring(5, 10);
    date = date.replace(/-/g, '月');
    return date;
}

export function hideNodeWithAll(node) {
    node.s('3d.visible', false);
    if (node.hasChildren()) {
        node.eachChild(c => {
            hideNodeWithAll(c);
        });
    }
}

export function showNodeWithAll(node) {
    node.s('3d.visible', true);
    if (node.hasChildren()) {
        node.eachChild(c => {
            showNodeWithAll(c);
        });
    }
}

export function randomNumber(min, max) {
    let number = Math.floor(Math.random() * (max - min + 1) + min);
    return number;
}

export function numBetween(n1, n2) {
    let range = (n1 - n2) > 0 ? (n1 - n2) : (n2 - n1);
    return range;
}

export function showPanel(data) {
    ht.Default.startAnim({
        duration: 1000,
        easing: t => t,
        action: (v,t) => {
            data.setScaleX(data.getScaleX() + (1 - data.getScaleX()) * v);
        }
    });
}
export function hidePanel(data) {
    ht.Default.startAnim({
        duration: 1000,
        easing: t => t,
        action: (v,t) => {
            data.setScaleX(data.getScaleX() + (0 - data.getScaleX()) * v);
        }
    });
}

// 面板动画
export function panelAnim(panel, panelText) {
    let panel_index = panel.getScaleX();

    ht.Default.startAnim({
        duration: 200,
        easing: Easing.swing,
        action: (v, t) => {
            panel.setScaleX(panel_index + (1 - panel_index) * v);
        },
        finishFunc: () => {
            // this.weatherPanelContent.eachChild(c => {
            ht.Default.startAnim({
                duration: 1500,
                easing: Easing.swing,
                action: (v, t) => {
                    panelText.eachChild(c => {
                        c.s('opacity', c.s('opacity') + (1 - c.s('opacity')) * v);
                    });
                }
            });
            // })
        }
    });
}
